import React, {useEffect} from "react";
import PageIvrSpecialCliFilter from "./PageIvrSpecialCliFilter";
import PageIvrSpecialCliTable from "./PageIvrSpecialCliTable";
import {Spacer} from "../../../components/base/Spacer";
import {api} from "api/loginRoutes";
import {IVR_CLI_CREATE_MODIFY_API, IVR_CLI_REMOVE_API} from "../../../const/apiMethods";


export default (
    {
        list,
        loading,
        ivrList,
        getIvrCliList,
        getIvrList,
    }
) => {

    useEffect(() => {
        getIvrCliList();
        getIvrList();
    }, []);


    const handleSubmit = (formValue, data) => {
        
        const params = {
            target: {
                ivr_id: formValue.ivr_id
            },
            prefix: formValue.prefix || data.prefix
        }

        if (formValue.description) {
            params.description = formValue.description;
        }

        return api(IVR_CLI_CREATE_MODIFY_API, params).then(r => r)
    }

    const handleRemove = (prefix) => {
        return api(IVR_CLI_REMOVE_API, {
            prefix: prefix
        }).then(r => r)
    }


    return (
        <>
            <Spacer size={30}/>
            
            <PageIvrSpecialCliFilter
                style={{flexShrink: 0}}
            />

            <Spacer size={30}/>

            <PageIvrSpecialCliTable
                data={list}
                loading={loading}
                getIvrCliList={getIvrCliList}
                ivrList={ivrList}
                handleSubmit={handleSubmit}
                handleRemove={handleRemove}
            />
        </>
    )
};